module.exports = __webpack_public_path__ + "img/applicationConstruction-ui.d64f8ef8.png";